<template>
  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-one">
          <a-select
              v-model:value="searchForm.status"
              allowClear
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option :value="0">待上报</a-select-option>
            <a-select-option :value="1">上报中</a-select-option>
            <a-select-option :value="2">上报成功</a-select-option>
            <a-select-option :value="3">上报失败</a-select-option>
          </a-select>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.order_no"
              allowClear placeholder="订单号|外部单号"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.hid"
              allowClear
              placeholder="房间ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.lockCode"
              allowClear
              placeholder="设备编码"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.keyword"
              :loading="searchLoading"
              placeholder="房间名称|姓名|手机号|证件号"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-popover
              v-model:visible="visiblePopover"
              placement="bottom"
              trigger="click"
          >
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button
                  size="small"
                  style="margin-right: 5px"
                  @click="handleResetCheck"
              >重置
              </a-button
              >
              <a-button class="btn-primary" size="small" @click="handleCheck"
              >确认
              </a-button
              >
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 8 ? columns.length*130 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
              type="link"
              @click="
              detShow = true;
              orderId = record.order_id;
            "
          >{{ record.order_no }}
          </a-button
          >
        </template>
        <template v-if="column.key == 'status_text'">
          <span v-if="record.status == 1" class="f-c-red">{{ record.status_text }}</span>
          <span v-else-if="record.status == 2" class="f-c-green">{{ record.status_text }}</span>
          <span v-else class="f-c-red">{{ record.status_text }}</span>
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />
    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />
  </div>
</template>

<script>
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {guotaiOpenDoor,} from "@/api/api";
import {AppstoreOutlined,} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index";
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";

export default {
  components: {
    OrderDetails,
    AppstoreOutlined,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        status: [],
        hid: '',
        lockCode: '',
        keyword: "",
        order_no: "",
        start: 0,
        limit: 20,
      },
      rangePicker: [],
      visiblePopover: false,
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handleReset() {
        search.searchForm.keyword = "";
        search.searchForm.order_no = "";
        search.searchForm.hid = "";
        search.searchForm.status = "";
        search.searchForm.lockCode = "";
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    function getColumns() {
      return [
        {
          title: "记录ID",
          dataIndex: "id",
          key: "id",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "房间ID",
          dataIndex: "hid",
          key: "hid",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "房间名称",
          dataIndex: "hname",
          key: "hname",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "入住ID",
          dataIndex: "tid",
          key: "tid",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "开锁编码",
          dataIndex: "unlockCode",
          key: "unlockCode",
          width: 120,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "设备编码",
          dataIndex: "lockCode",
          key: "lockCode",
          width: 120,
          isShow: true,
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: '苏州公安上报状态',
          dataIndex: 'szga_report_status',
          key: 'szga_report_status',
          width: 150,
          customRender({ record }) {
            const statusMap = {
              0: '待上报',
              1: '上报中',
              2: '上报成功',
              3: '上报失败',
            };
            return statusMap[record.szga_report_status] ?? record.szga_report_status_text ?? '-';
          },
        },
        {
          title: "上报时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 130,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "上报备注",
          dataIndex: "remark",
          key: "remark",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "证件号",
          dataIndex: "certNum",
          key: "certNum",
          width: 130,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "手机号",
          dataIndex: "phone",
          key: "phone",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "房屋编码",
          dataIndex: "roomCode",
          key: "roomCode",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "商户编码",
          dataIndex: "hotelCode",
          key: "hotelCode",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "商户编码",
          dataIndex: "hotelCode",
          key: "hotelCode",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "开锁人类型",
          dataIndex: "personType",
          key: "personType",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
          customRender: ({record}) => {
            if (record.personType === 1) {
              return '旅客';
            } else {
              return '从业人员';
            }
          },
        },
        {
          title: "旅客类别",
          dataIndex: "guestType",
          key: "guestType",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
          customRender: ({record}) => {
            if (record.guestType === 1) {
              return '境内';
            } else {
              return '境外';
            }
          },
        },
        {
          title: "证件类型",
          dataIndex: "certTypeName",
          key: "certTypeName",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "旅客编码",
          dataIndex: "guestCode",
          key: "guestCode",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "开锁方式",
          dataIndex: "unlockType",
          key: "unlockType",
          width: 80,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.unlockType === 1) {
              return '钥匙开锁';
            } else if (record.unlockType === 2) {
              return '蓝牙开锁';
            } else if (record.unlockType === 3) {
              return '静态密码开锁';
            } else if (record.unlockType === 4) {
              return '动态密码开锁';
            } else if (record.unlockType === 5) {
              return '门卡开锁';
            } else if (record.unlockType === 6) {
              return '证件开锁';
            } else if (record.unlockType === 7) {
              return '人脸开锁';
            } else if (record.unlockType === 8) {
              return '指纹开锁';
            } else if (record.unlockType === 9) {
              return '门内开锁';
            } else if (record.unlockType === 10) {
              return '远程开锁';
            } else {
              return '其他';
            }
          },
        },
        {
          title: "开锁时间",
          dataIndex: "unlockTime",
          key: "unlockTime",
          width: 160,
          isShow: true,
          align: "center",
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        guotaiOpenDoor(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              nextTick(() => {
                table.columns = getColumns();
                table.initColumns = getColumns();
              });
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: getColumns(),
    });
    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableData();
      },
    });


    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 80;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 80;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}
</style>
